import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.8523 13.2513C8.13261 13.3158 5.42399 15.8176 4.67155 19.1657C4.54235 19.7406 5.00917 20.25 5.59842 20.25H11.5M11.8523 13.2513C11.9014 13.2504 11.9506 13.25 12 13.25C12.3521 13.25 12.6954 13.2717 13.029 13.3138M11.8523 13.2513C11.2022 13.2626 10.5834 13.3483 10.0001 13.5M13.029 13.3138C13.3627 13.3559 13.6867 13.4184 14.0004 13.5M13.029 13.3138C13.7309 13.4024 14.3904 13.5812 15 13.838M14.75 18.6L16.95 20.25L20.25 14.75M15.75 6.5C15.75 8.57107 14.0711 10.25 12 10.25C9.92894 10.25 8.25 8.57107 8.25 6.5C8.25 4.42893 9.92894 2.75 12 2.75C14.0711 2.75 15.75 4.42893 15.75 6.5Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }